export const ROUTER = 'EQC_-t0nCnOFMdp7E7qPxAOCbCWGFz-e3pwxb6tTvFmshjt5';
export const POOL_FACTORY = 'EQDiNOe3qNffbCsEeX-6KYWT26TT1xL7D-dqx47-qqEkp4e9';
export const pTON_MINTER = 'EQCUnExmdgwAKADi-j2KPKThyQqTc7U650cgM0g78UzZXn9J';
export const pTON_ROUTER_WALLET =
  'EQCHHakhWxSQIWbw6ioW21YnjVKBCDd_gVjF9Mz9_dIuFy23';
